<template>
  <div class="m-card" :style="`flex: 0 0 ${(col / 12) * 100}%;`">
    <el-card>
      <div class="m-card-buttons">
        <el-button
          v-for="(button, index) in buttons"
          :key="`${button.label}-${index}`"
          class="btn-icon"
          size="large"
          type="text"
          @click="onClick(index)"
        >
          <el-icon>
            <component :is="button.icon" />
          </el-icon>
        </el-button>
      </div>
      <slot></slot>
      <el-button class="btn-icon" size="large" type="success" style="width: 100%; margin-top: 10px" @click="handleViewClick"
        >View</el-button
      >
    </el-card>
  </div>
</template>
<script>
import { Back, Edit, Delete, CopyDocument, Histogram } from '@element-plus/icons-vue'
import { config } from '@/lib/helpers/config.helpers'

export default {
  components: { Back, Edit, Delete, CopyDocument, Histogram },
  props: {
    buttons: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    col: {
      type: [Number, String],
      default: 12,
    },
    id: {
      type: Number,
    },
    viewPage: {
      type: String,
    },
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    onClick(index) {
      this.buttons[index].callback('test')
    },
    handleViewClick() {
      window.location.href = `${config.adminV2Url}/advertisers/${this.id}`
    },
  },
}
</script>
<style scoped lang="scss">
.m-card {
  position: relative;
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 20px;
  margin-top: 20px;
}
.m-card-buttons {
  position: absolute;
  top: 10px;
  right: 24px;
  display: flex;
  gap: 14px;
}
.btn-icon {
  font-size: 18px;
}

:deep(.m-card-buttons) {
  .el-button--large {
    padding: 0;
    margin: 0;
  }
}
</style>
